import * as React from 'react'

import {
  ContentMasthead,
  ContentMastheadProps,
  ContentMastheadType,
} from '@thg-commerce/gravity-elements'

import { Category, Tag, PostAuthor } from '../../types'
import { useSiteConfig, useSiteDefinition } from '@thg-commerce/enterprise-core'
import { constructImageUrl } from '../ArticleHeaderRenderer'

interface CategoryHeaderRendererProps {
  category: Category | Tag | PostAuthor
  hasWebP
}

export const CategoryHeaderRenderer = ({
  category,
  hasWebP,
}: CategoryHeaderRendererProps) => {
  if (!category.name) {
    return null
  }

  const { useAlternativeCategoryPageLayout } = useSiteConfig()
  const { imageServiceURL } = useSiteDefinition()

  let headerType = ContentMastheadType.TEXTONLY
  let image: { type: string; imageUris: string[] } | null = null
  let fallbackImageUrl: string | undefined = undefined
  let subHeading: string | undefined = undefined

  if (category.__typename === 'Category') {
    fallbackImageUrl = category.categoryImage?.headerImage || undefined
    if (useAlternativeCategoryPageLayout) {
      headerType =
        category.categoryImage?.headerType &&
        category.categoryImage.headerType.toUpperCase() in ContentMastheadType
          ? ContentMastheadType[
              category.categoryImage?.headerType?.toUpperCase()
            ]
          : ContentMastheadType.TEXTONLY

      !category.categoryImage?.featuredImage &&
        (headerType = ContentMastheadType.TEXTONLY)

      image = constructImageUrl(
        headerType,
        category.categoryImage?.headerImage || undefined,
        hasWebP,
      )
    }
  }

  if (category.__typename === 'User') {
    fallbackImageUrl = category.avatar?.url || undefined
    subHeading = category?.userData?.subheader
      ? category?.userData?.subheader
      : undefined

    const fullImagePath = category?.profilePictureUrl?.replace(
      /^.+blogscdn.thehut.net\/(?=app|wp-content)/g,
      '',
    )
    const imageType = hasWebP ? 'webp' : 'original'

    image = fullImagePath
      ? {
          type: hasWebP ? 'image/webp' : 'image/jpeg',
          imageUris: [
            `${imageServiceURL}/xlarge/${imageType}/${fullImagePath} 2000w`,
          ],
        }
      : null

    headerType = ContentMastheadType.USER
  }

  const categoryHeaderProps: ContentMastheadProps = {
    image,
    subHeading,
    fallbackImageUrl,
    type: headerType,
    title: category.name,
    description: category.description || '',
  }

  return <ContentMasthead {...categoryHeaderProps} />
}
